import CustomDatePickerInput from "../../../../components/CustomDatePickerInput";
import React, { useEffect } from "react";
import { useField } from "react-final-form";

interface IEndDateInput {
  record: any;
}

const EndDateInput = ({ record }: IEndDateInput) => {
  const {
    input: { onChange },
  } = useField("route.assignedSubcontractor.endDate");
  const routeAssignedSubcontractorStartDate = useField(
    "route.assignedSubcontractor.startDate"
  );

  useEffect(() => {
    if (record) {
      if (record.endDate) {
        onChange(record.endDate);
      }
    }
  }, [record]);

  return (
    <CustomDatePickerInput
      name="route.assignedSubcontractor.endDate"
      label="Subcontractor End Date *"
      min={routeAssignedSubcontractorStartDate.input.value}
    />
  );
};

export default EndDateInput;
